import React from 'react';

const MaintenancePage = () => {
  return (
    <div
      style={{
        fontFamily: "'Roboto', sans-serif",
        background: "linear-gradient(to bottom, #333, #777)",
        color: "#d3d3d3",
        textAlign: "center",
        margin: 0,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundAttachment: "fixed",
      }}
    >
      <div>
        <h1 style={{ fontSize: "3rem", color: "white" }}>Технічні роботи</h1>
        <img
          src="https://angelform.qpcore.com/logo192.png"
          alt="Maintenance Logo"
          style={{
            maxWidth: "150px",
            height: "auto",
            margin: "20px 0",
            borderRadius: "10px",
          }}
        />
        <p style={{ fontSize: "1.2rem", margin: "10px" }}>
          Сайт відпочиває, програми виконують лікувальні дії! Ми повернемось до Вас найближчим часом.
          <br />
          Дякуємо за твій спокій.
        </p>
        <p style={{ fontSize: "1rem", margin: "10px", color: "#bdbdbd" }}>
          New video:{" "}
          <a
            href="https://angelform.qpcore.com/go/youtube"
            style={{
              color: "white",
              textDecoration: "underline",
            }}
            onMouseOver={(e) => (e.target.style.textDecoration = "none")}
            onMouseOut={(e) => (e.target.style.textDecoration = "underline")}
          >
            Ruins
          </a>.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;




